import { useCallback, useEffect, useState } from "react"

import type { StyleTemplate } from "@/features/studio-ai/types/studio-ai.types"

import { useContentSidebarStore } from "@/stores/content-sidebar-store"

import { StyleTemplateCreator } from "./style-template-creator"
import { StyleTemplateManager } from "./style-template-manager"

export function StyleTemplateSidebarPanel() {
  const requestClose = useContentSidebarStore((state) => state.requestClose)
  const [mode, setMode] = useState<"manager" | "create" | "edit">("manager")
  const [editingTemplate, setEditingTemplate] = useState<StyleTemplate | null>(null)

  useEffect(() => {
    const state = useContentSidebarStore.getState()
    if (state.currentPanel?.id === "style-template-canvas" && !state.isFocused) {
      useContentSidebarStore.setState({ isFocused: true })
    }
  }, [])

  const handleBack = useCallback(() => {
    if (mode === "manager") {
      void requestClose()
      return
    }
    setMode("manager")
    setEditingTemplate(null)
  }, [mode, requestClose])

  const handleSaved = useCallback(() => {
    setMode("manager")
    setEditingTemplate(null)
  }, [])

  const handleCreate = useCallback(() => {
    setEditingTemplate(null)
    setMode("create")
  }, [])

  const handleEdit = useCallback((template: StyleTemplate) => {
    if (template.is_default) {
      // Presets cannot be edited — open as new template with prefilled data
      setEditingTemplate(template)
      setMode("create")
    } else {
      setEditingTemplate(template)
      setMode("edit")
    }
  }, [])

  return mode === "manager" ? (
    <StyleTemplateManager onBack={handleBack} onCreate={handleCreate} onEdit={handleEdit} />
  ) : (
    <StyleTemplateCreator
      mode={mode === "edit" ? "edit" : "create"}
      template={editingTemplate}
      onBack={handleBack}
      onSaved={handleSaved}
    />
  )
}
